function inBounds(bounds, x, y) {
    if (!bounds || bounds.width <= 0 || bounds.height <= 0)
        return false;
    return x >= bounds.left && x <= bounds.left + bounds.width
        && y >= bounds.top && y <= bounds.top + bounds.height;
}
/**
 * P2 (W1): mirror of the engine `findScaleSlotAt` — map a chart-local point
 * to the Y-axis scale slot under it (for the price-scale context menu).
 * Returns null for plot/time-axis/empty regions. Total function.
 */
export function findAxisSlotAt(snapshots, localX, localY) {
    if (!Array.isArray(snapshots) || !Number.isFinite(localX) || !Number.isFinite(localY)) {
        return null;
    }
    for (const snapshot of snapshots) {
        if (!snapshot)
            continue;
        const boundsMap = snapshot.scaleSlotBounds;
        if (!boundsMap)
            continue;
        for (const [slotId, bounds] of Object.entries(boundsMap)) {
            if (!inBounds(bounds, localX, localY))
                continue;
            const state = snapshot.scaleSlotStates?.[slotId];
            const side = state?.side === "left" ? "left" : "right";
            return { paneId: snapshot.paneId, scaleSlotId: slotId, side, domain: state?.domain };
        }
    }
    return null;
}
/** Log scale needs a strictly positive domain (engine falls back + warns otherwise). */
export function isLogScaleAvailable(domain) {
    if (!domain || domain.length < 2)
        return false;
    const [min, max] = domain;
    return typeof min === "number" && typeof max === "number" && min > 0 && max > 0;
}
